import React from 'react';

import { PromotionSectionCard } from './PromotionSectionCard';
import { TextInput } from '../../component/TextInput';

export function FunnelBannerSection({
  bannerCopy,
  setBannerCopy,
}: {
  bannerCopy: string;
  setBannerCopy: (v: string) => void;
}) {
  return (
    <PromotionSectionCard>
      <h2>
        Funnel Promotion Banner <span className="text-xs">(Optional)</span>
      </h2>
      <p className="text-xs text-gray-500 font-normal mb-2">
        Customer-facing banner to be displayed in the funnel
      </p>

      <div className="w-full mb-2">
        <h3 className="flex">All Pages (desktop & mobile)</h3>
        <TextInput placeholder="None" value={bannerCopy} setTextChange={setBannerCopy} />
      </div>
    </PromotionSectionCard>
  );
}
